import {
  SAVE_CONSENT_SUCCESS,
  SAVE_CONSENT_REQUEST,
  SAVE_CONSENT_ERROR,
} from "../../shared/constants/action-types";

const initialState = {
  hasFetched: false,
  isFetching: false,
  error: "",
  value: {},
};

const consentReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_CONSENT_REQUEST:
      return {
        ...initialState,
        ...action.payload,
        isFetching: true,
      };
    case SAVE_CONSENT_SUCCESS:
      return {
        ...state,
        hasFetched: true,
        isFetching: false,
        data: { type: SAVE_CONSENT_SUCCESS },
        accepted: action?.payload?.accepted,
        error: "",
      };
    case SAVE_CONSENT_ERROR:
      return {
        ...state,
        hasFetched: true,
        isFetching: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};

export default consentReducer;
